export function getUrlParameter(paramName, defaultValue) {
	const name = paramName.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
	const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
	const results = regex.exec(location.search)
	return results === null
		? defaultValue
		: decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export const redirectMuviflexCheck = () => {
	const URL_MUVIFLEX_HOME = 'muviflex.com.br'

	if (!location.hostname.includes(URL_MUVIFLEX_HOME)) {
		window.open(`https://${URL_MUVIFLEX_HOME}`, '_blank')
		return
	}

	window.scrollTo(0, 0)
}

export const redirectPlanaltoCheck = () => {
	const URL_PLANALTO_HOME = 'planalto.com.br'

	if (!location.hostname.includes(URL_PLANALTO_HOME)) {
		window.open(`https://${URL_PLANALTO_HOME}`, '_blank')
		return
	}

	window.scrollTo(0, 0)
}

export const checkURLTerm = (URL, term) => {
	return URL.toLowerCase().includes(term.toLowerCase())
}
